var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12175_5212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5429 5.61852H13.9287V17.503H20.5429V5.61852Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3496 11.5608C14.3496 9.25109 15.4205 7.04637 17.2263 5.61855C13.9507 3.03587 9.1843 3.6028 6.60162 6.89939C4.03994 10.175 4.60687 14.9204 7.90346 17.5031C10.6541 19.6658 14.4966 19.6658 17.2473 17.5031C15.4205 16.0752 14.3496 13.8705 14.3496 11.5608Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4675 11.5608C29.4675 15.7393 26.087 19.1199 21.9085 19.1199C20.2077 19.1199 18.5699 18.5529 17.2471 17.5031C20.5227 14.9204 21.0896 10.175 18.5069 6.87839C18.129 6.41645 17.709 5.9755 17.2471 5.61855C20.5227 3.03587 25.2891 3.6028 27.8507 6.89939C28.9006 8.22222 29.4675 9.86002 29.4675 11.5608Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12175_5212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.8,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.b1f9d919458158f80848107387bd0f6b.svg";
export { ForwardRef as ReactComponent };